export const environment = {
  production: false,
  hpssites_url: 'https://hpssites-uat.saint-gobain.com',
  spn_authent_client_id: '5d8d1a36-9b60-4894-9230-684c004899fd',
  loader_debug: true
};
